module.exports = __webpack_public_path__ + "static/EGR_FlashPage_4-51d02c72050b8a8f9c8224f15ef64894.jpg";